import { PatientNoteAiSummaryGradientBannerContainer } from '~/components/maud/patients/note/aiSummaryBanner/PatientNoteAiSummaryGradientBannerContainer';
import {
  ChakraFlex,
  FAIconName,
  FireflyIconButton,
  Text,
} from '@equip.health/ui';
import AiBoltIcon from '~/assets/svg/AiBoltIcon';
import { useCreateAiSummaryReviewMutation } from '~/store/services/notes/aiGeneratedNoteSessionSummary';
import { GetAigssResponse } from '~/lib/types/notes/GetAigssResponse';
import { AiSummaryReviewRating } from '~/lib/types/notes/AiSummaryReviewRating';
import { useState } from 'react';
import { PatientNoteAiSummaryNegativeFeedbackModal } from '~/components/maud/patients/note/aiSummaryBanner/PatientNoteAiSummaryNegativeFeedbackModal';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import { AISummaryEvents } from '~/analytics/aiSummaryEvents';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { AnalyticsEvent } from '~/analytics';

type Props = {
  aigssSummary: GetAigssResponse;
};
export const PatientNoteAiSummaryFeedbackBanner = ({ aigssSummary }: Props) => {
  const [createAiSummaryReview, { isLoading: isCreateAiSummaryReviewLoading }] =
    useCreateAiSummaryReviewMutation();
  const [hasSubmittedFeedback, setHasSubmittedFeedback] = useState(false);
  const [isNegativeFeedbackModalOpen, setIsNegativeFeedbackModalOpen] =
    useState(false);
  const { trackEvent } = useAnalytics();

  const sendAnalyticsEvent = (analyticsEvent: AnalyticsEvent) => {
    trackEvent(analyticsEvent, {
      Source: AnalyticsSourceValues.SESSION_GUIDE,
    });
  };

  return (
    <PatientNoteAiSummaryGradientBannerContainer>
      <ChakraFlex alignItems="center">
        <AiBoltIcon />
        <Text marginLeft="7px" variant="body">
          Was this AI Summary helpful?
        </Text>
      </ChakraFlex>
      <ChakraFlex alignItems="center">
        <FireflyIconButton
          ariaLabel="Rate this AI summary as helpful"
          icon={FAIconName.thumbsUpRegular}
          id="patient-note-ai-summary-thumbs-up"
          isDisabled={isCreateAiSummaryReviewLoading || hasSubmittedFeedback}
          isLoading={isCreateAiSummaryReviewLoading}
          onClick={() => {
            sendAnalyticsEvent(AISummaryEvents.aiSummaryRatedPositively);
            createAiSummaryReview({
              itemCode: 'APPOINTMENT',
              itemId: aigssSummary.appointmentId,
              ratingId: AiSummaryReviewRating.POSITIVE,
            }).then(() => setHasSubmittedFeedback(true));
          }}
          variant="tertiary"
        />
        <FireflyIconButton
          ariaLabel="Rate this AI summary as unhelpful"
          icon={FAIconName.thumbsDownRegular}
          id="patient-note-ai-summary-thumbs-down"
          isDisabled={isCreateAiSummaryReviewLoading || hasSubmittedFeedback}
          onClick={() => {
            sendAnalyticsEvent(AISummaryEvents.aiSummaryRatedNegatively);
            setIsNegativeFeedbackModalOpen(true);
          }}
          variant="tertiary"
        />
      </ChakraFlex>
      <PatientNoteAiSummaryNegativeFeedbackModal
        appointmentId={aigssSummary.appointmentId}
        isOpen={isNegativeFeedbackModalOpen}
        onClose={() => setIsNegativeFeedbackModalOpen(false)}
        onSubmit={() => setHasSubmittedFeedback(true)}
      />
    </PatientNoteAiSummaryGradientBannerContainer>
  );
};
